"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetKeyboardKeyState = void 0;
const types_1 = require("../../../../types");
const foundation_1 = require("../../../foundation");
/**
 * Resets the keyboard state for the given keyboard key
 *
 * @param key The key whose state we are resetting
 */
const resetKeyboardKeyState = (key) => {
    const normalizedKey = key || (key && key.toString());
    const keyboardState = (0, foundation_1.getKeyboardState)();
    if (!keyboardState[normalizedKey]) {
        return;
    }
    keyboardState[normalizedKey].value = types_1.KeyPressState.Reset;
    keyboardState[normalizedKey].lastKeyDownMs = 0;
};
exports.resetKeyboardKeyState = resetKeyboardKeyState;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzZXRLZXlib2FyZEtleVN0YXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvcmUvaW5wdXQvaW5wdXQtcHJvY2Vzc29ycy9rZXlib2FyZC9yZXNldEtleWJvYXJkS2V5U3RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELDZDQUErRDtBQUMvRCxvREFBdUQ7QUFFdkQ7Ozs7R0FJRztBQUNJLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxHQUF5QixFQUFRLEVBQUU7SUFDckUsTUFBTSxhQUFhLEdBQUksR0FBYyxJQUFJLENBQUMsR0FBRyxJQUFJLEdBQUcsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFDO0lBRWpFLE1BQU0sYUFBYSxHQUFHLElBQUEsNkJBQWdCLEdBQUUsQ0FBQztJQUV6QyxJQUFJLENBQUMsYUFBYSxDQUFDLGFBQWEsQ0FBQyxFQUFFLENBQUM7UUFDaEMsT0FBTztJQUNYLENBQUM7SUFDRCxhQUFhLENBQUMsYUFBYSxDQUFDLENBQUMsS0FBSyxHQUFHLHFCQUFhLENBQUMsS0FBSyxDQUFDO0lBQ3pELGFBQWEsQ0FBQyxhQUFhLENBQUMsQ0FBQyxhQUFhLEdBQUcsQ0FBQyxDQUFDO0FBQ25ELENBQUMsQ0FBQztBQVZXLFFBQUEscUJBQXFCLHlCQVVoQyJ9